<template>
    <div>
        <div class="row justify-content-center mt-5">
            <div class="col-md-5">
                <img src="@/assets/img/website-maintenance.svg" alt="">
            </div>
            <div class="col-md-4">
                <h2 class="text-danger mb-4">ATENÇÃO</h2>
                <p>A API do Gescomex está indisponível no momento. Estamos trabalhando para que os serviços voltem ao normal o mais rápido possível. Qualquer dúvida, entre em contato com a nossa equipe.</p>
                <p class="mt-2">
                    Atenciosamente,
                    <br />
                    Equipe de Tech da Prime
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import config from '@/config.js';

export default {
    name: 'InactiveAPI',
    data() {
        return {
            pollInterval: null
        };
    },
    mounted() {
        this.startPolling();
    },
    beforeDestroy() {
        this.stopPolling();
    },
    methods: {
        async checkAPIStatus() {
            try {
                const response = await Axios.get(`${config.env.API_DEFAULT.host}/credential`);
                if (response.status === 200) {
					const previousRoute = window.localStorage.getItem('previousRoute');
					if (previousRoute) {
						window.localStorage.removeItem('previousRoute');
						this.stopPolling();
						this.$router.push(previousRoute);
						
					} else {
						window.localStorage.removeItem('previousRoute');
						this.stopPolling();
						this.$router.push({ name: "dashboard" });
					}
                }
            } catch (error) {
                console.log('API ainda indisponível, tentando novamente em 10 segundos...');
            }
        },
        startPolling() {
            this.checkAPIStatus(); // Verifica imediatamente
            this.pollInterval = setInterval(() => {
                this.checkAPIStatus();
            }, 10000); // Verifica a cada 10 segundos
        },
        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
                this.pollInterval = null;
            }
        }
    }
};
</script>

<style scoped>
.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>